<script>

import Editor from './Editor'

export default {

    extends: Editor,

    computed: {

        canvasBlock() {
            // Get canvas block.
            let canvasBlockId = this.element.data('canvasEditable').blockId;
            let canvasBlocks = this.pageState.id2canvasBlock;

            return canvasBlocks[canvasBlockId];
        },

        panelComponent() {
            let componentTagPrefixComponentNamespace = '',
                canvasBlockName = '';

            // Determine component prefix and canvas block name
            if (this.canvasBlock.block.includes('::')) {
                componentTagPrefixComponentNamespace = this.canvasBlock.block.split('::')[0] + '--';
                canvasBlockName = this.canvasBlock.block.split('::')[1].replace('.', '-').toLowerCase();
            } else {
                canvasBlockName = this.canvasBlock.block.replace('.', '-').toLowerCase();
            }

            // Determine of component tag begin.
            let componentTagPrefix = componentTagPrefixComponentNamespace + 'common-canvas-blocks-' + canvasBlockName + '-admin-';

            // Panel given?
            if (this.editableData.panel) {
                // Get panel.
                let panelComponent = window.Vue.options.components[componentTagPrefix + this.editableData.panel.toLowerCase()];

                // Error due to not found?
                if (!panelComponent)
                    throw new {
                        msg: 'Panel component not found!',
                        block: this.canvasBlock.block,
                        panel: this.editableData.panel
                    };

                //
                return panelComponent;
            }
            // Try to find a block panel due to is block editor?
            else if (this.isBlockEditor)
                return window.Vue.options.components[componentTagPrefix + 'blockpanel'];

            //
            else
                return null;
        },

    },

}

</script>